<template>
  <div class="chart-condition">
    <div id="liquidChart"></div>
  </div>
</template>
<script>
import * as echarts from "echarts"
import { toRaw } from "@vue/reactivity"
import "echarts-liquidfill"
export default {
  data() {
    return {
      // 柱状图数据
      barData: [
        {
          value: 0,
          isNull: true,
        },
        {
          value: 0,
          isNull: true,
        },
        {
          value: 0,
          isNull: true,
        },
        {
          value: 0,
          isNull: true,
        },
      ],
      myChart: null,
      barOption: {}, //柱状图echarts
    };
  },
  props: {
    clientWidth: {
      type: Number,
      default: () => {
        return null;
      }
    },
    robLubsData: {
      type: Object,
      default: () => {
        return null;
      }
    },
    changeWidth: {
      type: Boolean,
      default: () => {
        return null;
      }
    },
  },
  computed: {},
  watch: {
    robLubsData(newV) {
      this.updateData(newV)
    },
    changeWidth(newV) {
      if (newV) {
        this.resizeCharts();
      }
    },
  },
  methods: {
    // 获取图表数据
    updateData(value) {
      this.isShowInfo = false
      let barData = []
      this.stockData = ""
      this.expendData = ""
      let obj = toRaw(value);
      for (let i in obj) {
        let condition = {};
        switch (i) {
          case "mecyl_h":
            if (obj[i] || obj[i] > 0) {
              condition = {
                value: obj[i],
                isNull: false,
                itemStyle: {
                  color: obj[i] < 1800 ? "#e14b4b" : "#02adf5",
                },
              };
            } else {
              condition = {
                value: 0,
                isNull: true,
                itemStyle: {
                  color: "#ec2f44",
                },
              };
            }
            barData.push(condition);
            break;
          case "mecyl_l":
            if (obj[i] || obj[i] > 0) {
              condition = {
                value: obj[i],
                isNull: false,
                itemStyle: {
                  color: obj[i] < 1800 ? "#e14b4b" : "#02adf5",
                },
              };
            } else {
              condition = {
                value: 0,
                isNull: true,
                itemStyle: {
                  color: "#ec2f44",
                },
              };
            }
            barData.push(condition);
            break;
          case "mesys":
            if (obj[i] || obj[i] > 0) {
              condition = {
                value: obj[i],
                isNull: false,
                itemStyle: {
                  color: obj[i] < 3000 ? "#e14b4b" : "#02adf5",
                },
              };
            } else {
              condition = {
                value: 0,
                isNull: true,
                itemStyle: {
                  color: "#ec2f44",
                },
              };
            }
            barData.push(condition);
            break;
          case "aesys":
            if (obj[i] || obj[i] > 0) {
              condition = {
                value: obj[i],
                isNull: false,
                itemStyle: {
                  color: obj[i] < 800 ? "#e14b4b" : "#02adf5",
                },
              };
            } else {
              condition = {
                value: 0,
                isNull: true,
                itemStyle: {
                  color: "#ec2f44",
                },
              };
            }
            barData.push(condition);
            break;
          default:
            break;
        }
      }
      this.barData = barData;
      this.initData();
    },
    // 处理图表
    initChart(data, chart) {
      data && chart.setOption(data);
    },

    resizeCharts() {
      if (this.myChart) {
        this.myChart.resize();
      }
      if (this.myChart2) {
        this.myChart2.resize();
      }
    },
    // 存入数据
    initData() {
      if (this.myChart) {
        this.myChart.dispose();
      }
      var chartDom = document.getElementById("liquidChart");
      this.myChart = echarts.init(chartDom);
      if (this.clientWidth <= 1921) {
        this.initDataUnder1920();
      } else if (this.clientWidth > 1921 && this.clientWidth <= 2560) {
        this.initDataUnder2560();
      } else {
        this.initDataUp4368();
      }

      this.initChart(this.barOption, this.myChart);
    },
    // 完成series数据存储
    handlerData() {},
    initDataUnder1920() {
      this.barOption = {
        grid: {
          top: '25%',
          bottom: '15%',
        },
        xAxis: {
          type: 'category',
          data: ['ME Cyl-H', 'ME Cyl-L', 'ME Sys', 'AE Sys'],
          axisTick: {
            show: false, //是否显示网状线 默认为true
          },
          axisLabel: {
            textStyle: {
              //textStyle里面写x轴下的字体的样式
              color: '#fff',
              fontSize: 11,
            },
          },
          axisLine: {
            show: true, //这里的show用于设置是否显示x轴那一条线 默认为true
            lineStyle: {
              //lineStyle里面写x轴那一条线的样式
              color: '#fff',
              width: 1, //轴线的粗细 我写的是2 最小为0，值为0的时候线隐藏
            },
          },
        },
        yAxis: {
          type: 'value',
          name: '单位: Ltr',
          splitLine: { show: false }, //去除网状线 默认为true
          //用于设置y轴的字体
          axisLabel: {
            show: false, //这里的show用于设置是否显示y轴下的字体 默认为true
          },
          //用于设置y轴的那一条线
          axisLine: {
            show: false, //这里的show用于设置是否显示y轴那一条线 默认为true
          },
          position: 'right',
          nameTextStyle: {
            color: '#ffffff',
            fontSize: 12,
          }
        },
        series: [
          {
            data: this.barData,
            type: "bar",
            label: {
              show: true,
              position: "top",
              formatter: function (params) {
                if (params.data.isNull == true) {
                  return "--";
                }
                return Number(params.data.value);
              },
              color: "inherit",
              fontSize: 11,
              borderType: 0,
            },
            barWidth: 20, //柱图宽度,
          },
        ],
      }
    },
    initDataUnder2560() {
      this.barOption = {
        color: ['#02a7ef'],
        grid: {
          top: '20%',
          bottom: '20%',
        },
        xAxis: {
          type: 'category',
          data: ['ME Cyl-H', 'ME Cyl-L', 'ME Sys', 'AE Sys'],
          axisTick: {
            show: false, //是否显示网状线 默认为true
          },
          axisLabel: {
            textStyle: {
              //textStyle里面写x轴下的字体的样式
              color: '#fff',
              fontSize: 20,
            },
          },
          axisLine: {
            show: true, //这里的show用于设置是否显示x轴那一条线 默认为true
            lineStyle: {
              //lineStyle里面写x轴那一条线的样式
              color: '#fff',
              width: 1, //轴线的粗细 我写的是2 最小为0，值为0的时候线隐藏
            },
          },
        },
        yAxis: {
          name: '单位: Ltr',
          type: 'value',
          splitLine: { show: false }, //去除网状线 默认为true
          //用于设置y轴的字体
          axisLabel: {
            show: false, //这里的show用于设置是否显示y轴下的字体 默认为true
          },
          //用于设置y轴的那一条线
          axisLine: {
            show: false, //这里的show用于设置是否显示y轴那一条线 默认为true
          },
          position: 'right',
          nameTextStyle: {
            color: '#ffffff',
            fontSize: 14,
          }
        },
        series: [
          {
            data: this.barData,
            type: "bar",
            label: {
              show: true,
              position: "top",
              formatter: function (params) {
                if (params.data.isNull == true) {
                  return "--";
                }
                return params.data.value
              },
              color: "inherit",
              fontSize: 20,
            },
            barWidth: 25, //柱图宽度,
          },
        ],
      }
    },
    initDataUp4368() {
      this.barOption = {
        color: ['#02a7ef'],
        grid: {
          top: '15%',
          bottom: '15%',
        },
        xAxis: {
          type: 'category',
          data: ['ME Cyl-H', 'ME Cyl-L', 'ME Sys', 'AE Sys'],
          axisTick: {
            show: false, //是否显示网状线 默认为true
          },
          axisLabel: {
            textStyle: {
              //textStyle里面写x轴下的字体的样式
              color: '#fff',
              fontSize: 24,
            },
          },
          axisLine: {
            show: true, //这里的show用于设置是否显示x轴那一条线 默认为true
            lineStyle: {
              //lineStyle里面写x轴那一条线的样式
              color: '#fff',
              width: 1, //轴线的粗细 我写的是2 最小为0，值为0的时候线隐藏
            },
          },
        },
        yAxis: {
          name: '单位: Ltr',
          type: 'value',
          splitLine: { show: false }, //去除网状线 默认为true
          //用于设置y轴的字体
          axisLabel: {
            show: false, //这里的show用于设置是否显示y轴下的字体 默认为true
          },
          //用于设置y轴的那一条线
          axisLine: {
            show: false, //这里的show用于设置是否显示y轴那一条线 默认为true
          },
          position: 'right',
          nameTextStyle: {
            color: '#ffffff',
            fontSize: 16,
          }
        },
        series: [
          {
            data: this.barData,
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              formatter: function (params) {
                if (params.data.isNull == true) {
                  return '--';
                }
                return params.data.value
              },
              color: 'inherit',
              fontSize: 24,
            },
            barWidth: 30, //柱图宽度,
          },
        ],
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateData(this.robLubsData)
    })
  },
  beforeUnmount() {
    if (this.myChart) {
      this.myChart.dispose();
    }
  }
};
</script>
<style lang="scss" scoped>
.chart-condition {
  width: 90% !important;
  height: 100%;
  margin: 0 auto !important;
  display: flex !important;
  flex-direction: column !important;
  #liquidChart {
    width: 100%;
    height: 100%;
  }
}
@media screen and (max-width: 1920px) {
  .expect {
    width: 100%;
    height: 10%;
    font-size: 14px;
    .expect-day {
      color: #d22e44;
      font-weight: 800;
      font-size: 12px;
    }
  }
  .info {
    background-color: #d22e4456;
    display: flex;
    justify-content: space-between;
    width: 60%;
    border-radius: 3px;
    padding: 3px;
    position: absolute;
    right: 3%;
    top: calc(31.5vh);
    .info-text {
      color: white;
      font-size: 12px;
      display: flex;
      align-items: center;
      i {
        font-size: 14px;
        margin-right: 3px;
      }
    }
  }
  .tips {
    font-size: 10px;
  }
}
@media screen and (min-width: 1921px) {
  .expect {
    width: 100%;
    height: 10%;
    font-size: 14px;
    .expect-day {
      color: #d22e44;
      font-weight: 800;
      font-size: 12px;
    }
  }
  .info {
    background-color: #d22e4456;
    display: flex;
    justify-content: space-between;
    width: 60%;
    border-radius: 3px;
    padding: 3px;
    position: absolute;
    right: 3%;
    top: calc(31.5vh);
    .info-text {
      color: white;
      font-size: 12px;
      display: flex;
      align-items: center;
      i {
        font-size: 14px;
        margin-right: 3px;
      }
    }
  }
  .tips {
    font-size: 20px;
  }
}

@media screen and (min-width: 2560px) {
  .expect {
    width: 100%;
    height: 10%;
    font-size: 26px;
    .expect-day {
      color: #d22e44;
      font-weight: 800;
      font-size: 24px;
    }
  }
  .info {
    background-color: #d22e4456;
    display: flex;
    justify-content: space-between;
    width: 60%;
    border-radius: 3px;
    padding: 3px;
    position: absolute;
    right: 3%;
    top: calc(1.5vh);
    .info-text {
      color: white;
      font-size: 24px;
      display: flex;
      align-items: center;
      i {
        font-size: 26px;
        margin-right: 3px;
      }
    }
  }
  .tips {
    font-size: 24px;
  }
}

@media screen and (min-width: 4360px) {
  .expect {
    width: 100%;
    height: 10%;
    font-size: 32px;
    .expect-day {
      color: #d22e44;
      font-weight: 800;
      font-size: 30px;
    }
  }
  .info {
    background-color: #d22e4456;
    display: flex;
    justify-content: space-between;
    width: 60%;
    border-radius: 3px;
    padding: 3px;
    position: absolute;
    right: 3%;
    top: calc(1.5vh);
    .info-text {
      color: white;
      font-size: 30px;
      display: flex;
      align-items: center;
      i {
        font-size: 32px;
        margin-right: 3px;
      }
    }
  }
  .tips {
    font-size: 30px;
  }
}
@media screen and (min-width: 6720px) {
  .expect {
    width: 100%;
    height: 10%;
    font-size: 42px;
    .expect-day {
      color: #d22e44;
      font-weight: 800;
      font-size: 40px;
    }
  }
  .info {
    background-color: #d22e4456;
    display: flex;
    justify-content: space-between;
    width: 60%;
    border-radius: 3px;
    padding: 3px;
    position: absolute;
    right: 3%;
    top: calc(1.5vh);
    .info-text {
      color: white;
      font-size: 40px;
      display: flex;
      align-items: center;
      i {
        font-size: 42px;
        margin-right: 3px;
      }
    }
  }
  .tips {
    font-size: 40px;
  }
}
</style>

